import { useDispatch } from "react-redux"
import styled from "styled-components"
import { setSingleAiNewModelChatAllMessages } from "../../features/aiControl/aiControlSlice"
import { showModal } from "../../features/modal/modalSlice"

const Container = styled.div`
    width: 100%;
    color: ${({theme}) => theme.mainTextColor};
    background-color: ${({theme}) => theme.secondaryBgColor};
    padding: 10px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;

    .username{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
    }

    .message{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
    }
`

const AiMobileNewModelPastMessageItemContainer = ({item}) => {

    const dispatch = useDispatch()
    

  return (
    <Container onClick={() => {dispatch(setSingleAiNewModelChatAllMessages(item.messages.$values)); dispatch(showModal("aiMobileNewModelSingleChatDetails"))}}>
        <div className="username">{item.name}</div>
        <p className="message">{item.messages.$values[0]?.content}</p>
    </Container>
  )
}

export default AiMobileNewModelPastMessageItemContainer